import gql from 'graphql-tag';

export default gql`
  fragment leadSourceFragment on LeadSource {
    id
    name
  }
`;
